<template>
  <div>
    <search-tenant-package @submit="submitSearch" ref="searchForm" />

    <div class="custom-table-operation-buttons">
      <a-space>
        <router-link :to="{name:'tenant_package_items'}">
          <a-button type="primary">套餐项目池管理</a-button>
        </router-link>
        <a-button type="primary" @click="showSortModal">排序</a-button>
        <a-button type="primary" @click="showNewModal">新增</a-button>
      </a-space>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
      @change="sortChange"
    >
      <template slot="name" slot-scope="name,record">
        <span v-if="record.is_self_choose">{{ name }}</span>
        <router-link v-else :to="{name:'tenant_package_info',params:{id: record.id}}">{{ name }}</router-link>
      </template>
      <template slot="price" slot-scope="price,record">
        <span v-if="record.is_self_choose">-</span>
        <span v-else>{{ price | formatCurrency }}</span>
      </template>
      <template slot="images" slot-scope="imgs, record">
        <img v-if="imgs && imgs.length > 0" :src="imgs[0].url" style="height: 50px;width: 50px" @click="showImg(record)">
      </template>
      <div slot="effective" slot-scope="effective, record">
        <span
          v-if="record.info_modify_apply_user_id === $store.getters.userId &&
            (record.info_modify_apply_status === 'uncheck' || record.info_modify_apply_status === 'checking')"
        >申请处理中</span>
        <a-switch
          v-else
          :checked="effective"
          :loading="editingEffectiveId === record.id"
          @change="showApplyModal(record)"
        />
      </div>
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record)">编辑</a>
          <a @click="showOperationHistoryModal(record.id)">操作历史</a>
          <a @click="showMaintainModal(record)">维护家属告知书</a>
          <a style="color: red" v-if="record.self_choose === false" @click="showDeleteModal(record)">删除</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <!-- 新增套餐模态框 -->
    <new-tenant-package
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <!-- 编辑套餐模态框 -->
    <edit-tenant-package
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :record="editingRecord"
      @completed="fetchData"
    />

    <!-- 编辑套餐套餐有效性模态框 -->
    <effective-tenant-package
      v-if="isShowApplyModal"
      :visible.sync="isShowApplyModal"
      :record="editingRecord"
      @completed="fetchData"
    />
    <!-- 维护家属告知书模态框 -->
    <maintain-family-notification
      v-if="isShowMaintainModal"
      :visible.sync="isShowMaintainModal"
      :record="editingRecord"
      @completed="fetchData"
    />
    <!-- 预览图片 -->
    <preview-image
      :visible.sync="previewVisible"
      :images.sync="previewImages"
    />

    <operation-history-list-modal
      v-if="isShowOperationHistoryModal"
      :reference-id="showingOperationHistoryId"
      reference-type="Package"
      :visible.sync="isShowOperationHistoryModal"
    />
    <sort
      v-if="isShowSortModal"
      :visible.sync="isShowSortModal"
      :data="sortData"
      table-name="packages"
      name-title="套餐名称"
      @completed="fetchSortData"
    />
    <delete-tenant-package
      v-if="isShowDeleteModal"
      :visible.sync="isShowDeleteModal"
      :record="editingRecord"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchTenantPackage from '@/views/package_management/tenant/Search'
import PreviewImage from '@/components/PreviewImage'
import { findPackages, findSortPackages } from '@/api/package_management'

export default {
  name: 'TenantPackageList',
  components: {
    Pagination,
    PreviewImage,
    SearchTenantPackage,
    Sort: () => import('@/components/Sort'),
    NewTenantPackage: () => import('@/views/package_management/tenant/New'),
    EditTenantPackage: () => import('@/views/package_management/tenant/Edit'),
    MaintainFamilyNotification: () => import('@/views/package_management/tenant/MaintainFamilyNotification'),
    EffectiveTenantPackage: () => import('@/views/package_management/tenant/Effecitve'),
    OperationHistoryListModal: () => import('@/views/operation_histories/Modal'),
    DeleteTenantPackage: () => import('@/views/package_management/tenant/Delete')
  },
  data() {
    return {
      query: { effective: 'true' },
      data: [],
      loading: true,
      isShowNewModal: false, // 是否显示新增表单弹窗
      isShowEditModal: false, // 是否显示编辑表单弹窗
      isShowApplyModal: false, // 是否显示申请修改有效性表单弹窗
      isShowMaintainModal: false, // 是否显示维护家属告知书表单弹窗
      isShowDeleteModal: false, // 是否显示删除租户套餐弹窗
      editingEffectiveId: 0, // 正在修改有效性的记录id
      editingRecord: {}, // 正在编辑的记录id
      showingOperationHistoryId: 0,
      isShowOperationHistoryModal: false,
      previewVisible: false,
      isApplying: false,
      previewImages: [],
      isShowSortModal: false, // 是否显示排序弹窗
      sortData: [], // 排序弹窗页面数据
      pagination: {
        total_count: 0
      },
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.$EventBus.$on('showImg', val => {
      this.previewVisible = true
      this.previewImages = val.images
    })
  },
  destroyed() {
    this.$EventBus.$off('showImg')
  },
  computed: {
    isOutfieldServicePlace() {
      return this.$store.getters.tenantServicePlace === 'outfield'
    },
    columns() {
      let data = [
        {
          title: '套餐名称',
          dataIndex: 'name',
          width: 220,
          fixed: 'left',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '项目代码',
          dataIndex: 'code',
          width: 100
        },
        {
          title: '拼音码',
          dataIndex: 'pinyin',
          width: 100
        },
        {
          title: '所属殡仪馆',
          width: 150,
          dataIndex: 'funeral_home_names'
        },
        {
          title: '关联厅房',
          width: 150,
          dataIndex: 'relation_hall_names',
          ellipsis: true
        },
        {
          title: '项目数量',
          width: 90,
          dataIndex: 'itemCount'
        },
        {
          title: '价格(元)',
          width: 120,
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '图片',
          width: 100,
          dataIndex: 'images',
          scopedSlots: { customRender: 'images' }
        },
        {
          title: '套餐介绍',
          width: 150,
          dataIndex: 'remark',
          ellipsis: true
        },
        {
          title: '状态',
          width: 120,
          dataIndex: 'effective',
          scopedSlots: { customRender: 'effective' }
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          width: 180,
          sorter: true,
          sortOrder: this.sort.sort_field === 'created_at' ? this.sort.sort_order : false
        },
        {
          title: '操作',
          width: 280,
          fixed: 'right',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ]
      if (this.isOutfieldServicePlace) {
        data = data.filter(item => item.dataIndex !== 'relation_hall_names' && item.dataIndex !== 'funeral_home_names')
      }
      return data
    }
  },
  methods: {
    showImg(record) {
      this.previewVisible = true
      this.previewImages = record.images
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showSortModal() {
      findSortPackages().then((res) => {
        this.sortData = res.data
        this.isShowSortModal = true
      })
    },

    showEditModal(record) {
      this.editingRecord = record
      this.isShowEditModal = true
    },

    showApplyModal(record) {
      this.editingRecord = record
      this.isShowApplyModal = true
    },

    showMaintainModal(record) {
      this.editingRecord = record
      this.isShowMaintainModal = true
    },

    showDeleteModal(record) {
      this.editingRecord = record
      this.isShowDeleteModal = true
    },

    // 显示操作历史
    showOperationHistoryModal(id) {
      this.showingOperationHistoryId = id
      this.isShowOperationHistoryModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      // 重置排序
      this.sort = this.$options.data().sort
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    fetchSortData() {
      this.query = {}
      // 重置排序
      this.sort = this.$options.data().sort
      this.$refs.searchForm.clearForm()
      this.loading = true
      findPackages().then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    fetchData() {
      this.loading = true
      findPackages(Object.assign({}, this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
